function Cart({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width="${dimensions || 22}" height="${(dimensions * 20) / 22 || 20}" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5461 11C16.2961 11 16.9561 10.59 17.2961 9.97L20.8761 3.48C21.2461 2.82 20.7661 2 20.0061 2H5.20609L4.26609 0H0.996094V2H2.99609L6.59609 9.59L5.24609 12.03C4.51609 13.37 5.47609 15 6.99609 15H18.9961V13H6.99609L8.09609 11H15.5461ZM6.15609 4H18.3061L15.5461 9H8.52609L6.15609 4ZM6.99609 16C5.89609 16 5.00609 16.9 5.00609 18C5.00609 19.1 5.89609 20 6.99609 20C8.09609 20 8.99609 19.1 8.99609 18C8.99609 16.9 8.09609 16 6.99609 16ZM16.9961 16C15.8961 16 15.0061 16.9 15.0061 18C15.0061 19.1 15.8961 20 16.9961 20C18.0961 20 18.9961 19.1 18.9961 18C18.9961 16.9 18.0961 16 16.9961 16Z" fill="${col}"/>
    </svg>
  `;

  return baseXml;
}

export default Cart;
